import { getPermissions } from "@/helper/collection";

export const MarketingAutomationRoutes = {
  path: "marketing-automation",
  name: "Marketing Automation",
  redirect: "marketing-automation/marketing-automation-master",
  component: {
    render(c) {
      return c("router-view");
    }
  },
  children: [
    {
      path: "/",
      name: "",
      component: () =>
        import(
          "@/components/Pages/MarketingAutomationContainer/marketingAutomationMaster"
        ),
      meta: {}
    },
    {
      path: "email-campaigns",
      name: "Email Campaigns",
      component: () =>
        import(
          "@/components/Pages/MarketingAutomationContainer/EmailComponents/emailCampaign"
        ),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager", "RoleRoleManagement"],
          true,
          "",
          121,
          1
        )
      }
    },
    {
      path: "add-email-campaign/:token",
      name: "Add Email Campaign",
      component: () =>
        import(
          "@/components/Pages/MarketingAutomationContainer/EmailComponents/addEmailCampaign"
        ),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager", "RoleRoleManagement"],
          true,
          "",
          121,
          2
        )
      }
    },
    {
      path: "edit-email-campaign/:ec_id",
      name: "Edit Email Campaign",
      component: () =>
        import(
          "@/components/Pages/MarketingAutomationContainer/EmailComponents/editEmailCampaign"
        ),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager", "RoleRoleManagement"],
          true,
          "",
          121,
          2
        )
      }
    },
    {
      path: "view-email-campaign/:ec_id",
      name: "View Email Campaign",
      component: () =>
        import(
          "@/components/Pages/MarketingAutomationContainer/EmailComponents/viewEmailCampaign"
        ),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager", "RoleRoleManagement"],
          true,
          "",
          121,
          1
        )
      }
    },
    {
      path: "sms-campaigns",
      name: "SMS Campaigns",
      component: () =>
        import(
          "@/components/Pages/MarketingAutomationContainer/SmsComponents/smsCampaign"
        ),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager", "RoleRoleManagement"],
          true,
          "",
          122,
          1
        )
      }
    },
    {
      path: "add-sms-campaign/:token",
      name: "Add sms Campaign",
      component: () =>
        import(
          "@/components/Pages/MarketingAutomationContainer/SmsComponents/addSmsCampaign"
        ),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager", "RoleRoleManagement"],
          true,
          "",
          122,
          2
        )
      }
    },
    {
      path: "edit-sms-campaign/:sc_id",
      name: "Edit sms Campaign",
      component: () =>
        import(
          "@/components/Pages/MarketingAutomationContainer/SmsComponents/editSmsCampaign"
        ),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager", "RoleRoleManagement"],
          true,
          "",
          122,
          2
        )
      }
    },
    {
      path: "view-sms-campaign/:sc_id",
      name: "View sms Campaign",
      component: () =>
        import(
          "@/components/Pages/MarketingAutomationContainer/SmsComponents/viewSmsCampaign"
        ),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager", "RoleRoleManagement"],
          true,
          "",
          122,
          1
        )
      }
    },
    {
      path: "user-journey",
      name: "User Journey",
      component: () =>
        import(
          "@/components/Pages/MarketingAutomationContainer/UserJourneyComponents/userJourney.vue"
        ),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager", "RoleRoleManagement"],
          true,
          "",
          123,
          1
        )
      }
    },
    {
      path: "add-user-journey",
      name: "Add User Journey",
      component: () =>
        import(
          "@/components/Pages/MarketingAutomationContainer/UserJourneyComponents/addUserJourney.vue"
        ),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager", "RoleRoleManagement"],
          true,
          "",
          123,
          2
        )
      }
    },
    {
      path: "edit-user-journey",
      name: "Edit User Journey",
      component: () =>
        import(
          "@/components/Pages/MarketingAutomationContainer/UserJourneyComponents/editUserJourney.vue"
        ),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager", "RoleRoleManagement"],
          true,
          "",
          123,
          2
        )
      }
    },
    {
      path: "view-user-journey",
      name: "View User Journey",
      component: () =>
        import(
          "@/components/Pages/MarketingAutomationContainer/UserJourneyComponents/viewUserJourney.vue"
        ),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager", "RoleRoleManagement"],
          true,
          "",
          123,
          1
        )
      }
    },
    {
      path: "view-user-journey-flow/:cust_id",
      name: "View User Journey Flow",
      component: () =>
        import(
          "@/components/Pages/MarketingAutomationContainer/UserJourneyComponents/viewUserJourneyFlow.vue"
        ),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager", "RoleRoleManagement"],
          true,
          "",
          123,
          1
        )
      }
    },
    {
      path: "customer-list",
      name: "Customer List",
      component: () =>
        import(
          "@/components/Pages/MarketingAutomationContainer/UserJourneyComponents/customerList.vue"
        ),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager", "RoleRoleManagement"],
          true,
          "",
          123,
          1
        )
      }
    },
    {
      path: "segments",
      name: "Segments",
      component: () =>
        import(
          "@/components/Pages/MarketingAutomationContainer/Segments/Segments.vue"
        ),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager", "RoleRoleManagement"],
          true,
          "",
          124,
          1
        )
      }
    },
    {
      path: "add-segment",
      name: "Add Segment",
      component: () =>
        import(
          "@/components/Pages/MarketingAutomationContainer/Segments/addSegment.vue"
        ),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager", "RoleRoleManagement"],
          true,
          "",
          124,
          2
        )
      }
    },
    {
      path: "edit-segment/:segment_id",
      name: "Edit Segment",
      component: () =>
        import(
          "@/components/Pages/MarketingAutomationContainer/Segments/editSegment.vue"
        ),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager", "RoleRoleManagement"],
          true,
          "",
          124,
          2
        )
      }
    },
    {
      path: "view-segment/:segment_id",
      name: "View Segment",
      component: () =>
        import(
          "@/components/Pages/MarketingAutomationContainer/Segments/viewSegment.vue"
        ),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager", "RoleRoleManagement"],
          true,
          "",
          124,
          1
        )
      }
    }
  ]
};



// WEBPACK FOOTER //
// ./src/router/marketingAutomation.js